import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsSeguridad';
import AlertDialog from '../../../../Lms/Components/Shared/AlertDialog';

export default function ModuloReorderModal({ open, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);

    const [alertDialog, setAlertDialog] = useState({
        open: false,
        title: 'Información',
        message: '',
        variant: 'info'
    });

    useEffect(() => {
        if (!open) return;

        const loadItems = async () => {
            setLoading(true);
            try {
                const res = await axios.get(ENDPOINTS.modulos);
                const modulos = (res.data || []).map(m => Models.moduloSeguridad(m));
                modulos.sort((a, b) => (a.orden || 0) - (b.orden || 0));
                setItems(modulos);
            } catch (error) {
                console.error("Error cargando módulos para reordenar:", error);
                setAlertDialog({
                    open: true,
                    title: 'Error',
                    message: "Error al cargar la lista de módulos.",
                    variant: 'error'
                });
            } finally {
                setLoading(false);
            }
        };

        loadItems();
    }, [open]);

    const handleDragStart = (e, index) => {
        setDraggedItemIndex(index);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleDragOver = (e, index) => {
        e.preventDefault(); 
        e.dataTransfer.dropEffect = "move";

        if (draggedItemIndex === null) return;
        if (draggedItemIndex === index) return;

        const newItems = [...items];
        const draggedItem = newItems[draggedItemIndex];
        newItems.splice(draggedItemIndex, 1);
        newItems.splice(index, 0, draggedItem);

        setDraggedItemIndex(index);
        setItems(newItems);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDraggedItemIndex(null);
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const updates = items.map((item, index) => {
                const payload = {
                    idModulo: item.idModulo,
                    clave: item.clave,
                    nombre: item.nombre,
                    descripcion: item.descripcion || '',
                    rutaBase: item.rutaBase,
                    icono: item.icono || '',
                    activo: !!item.activo,
                    orden: index + 1
                };
                return axios.put(ENDPOINTS.modulos, payload);
            });

            await Promise.all(updates);
            if (onSuccess) onSuccess();
            onClose();
        } catch (error) {
            console.error("Error al guardar el orden:", error);
            setAlertDialog({
                open: true,
                title: 'Error',
                message: "Error al guardar el nuevo orden.",
                variant: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                width: '500px',
                maxWidth: '90%',
                maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
                <div className="roles-topbar" style={{ padding: '1rem', borderBottom: '1px solid #eee' }}>
                    <h3 className="roles-title" style={{ margin: 0 }}>Reordenar Módulos</h3>
                    <button className="roles-btn" onClick={onClose}>✕</button>
                </div>

                <div style={{ padding: '1rem', overflowY: 'auto', flex: 1 }}>
                    <p style={{ marginBottom: '1rem', color: '#666', fontSize: '0.9rem' }}>
                        Arrastra y suelta los elementos para cambiar su orden.
                    </p>

                    {loading && items.length === 0 ? (
                        <div>Cargando...</div>
                    ) : items.length === 0 ? (
                        <div style={{ padding: '2rem', textAlign: 'center', color: '#999' }}>
                            No hay módulos para ordenar.
                        </div>
                    ) : (
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {items.map((item, index) => (
                                <li
                                    key={item.idModulo}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onDragOver={(e) => handleDragOver(e, index)}
                                    onDrop={handleDrop}
                                    style={{
                                        padding: '0.8rem',
                                        marginBottom: '0.5rem',
                                        backgroundColor: draggedItemIndex === index ? '#f0f9ff' : '#f8f9fa',
                                        border: draggedItemIndex === index ? '1px dashed #0ea5e9' : '1px solid #e2e8f0',
                                        borderRadius: '6px',
                                        cursor: 'grab',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div>
                                            <div style={{ fontWeight: 500 }}>{item.nombre}</div>
                                            <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{item.clave}</div>
                                        </div>
                                    </div>
                                    <div style={{
                                        backgroundColor: '#e2e8f0',
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold',
                                        color: '#475569'
                                    }}>
                                        {index + 1}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div style={{ padding: '1rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <button className="btn-cancel" onClick={onClose} disabled={loading}>Cancelar</button>
                    <button className="btn-action" onClick={handleSave} disabled={loading || items.length === 0}>
                        {loading ? 'Guardando...' : 'Guardar Orden'}
                    </button>
                </div>
            </div>

            <AlertDialog
                open={alertDialog.open}
                title={alertDialog.title}
                message={alertDialog.message}
                variant={alertDialog.variant}
                onClose={() => {
                    setAlertDialog({ ...alertDialog, open: false });
                }}
                buttonText="Aceptar"
            />
        </div>
    );
}
